const QUERIES = {
  USERS_LIST: 'users-list',
  PRODUCT: {
    DETAIL: 'product-detail-by-id',
  },
  PRODUCT_CATEGORY: 'product-category',
  // E_CATALOGUE: {
  //   PRODUCT_DETAIL: 'product-detail',
  //   PARTNER_PRODUCT_DETAIL: 'partner-product-detail',
  //   PARTNER_PRODUCT_DETAIL_HISTORY: 'partner-product-detail-history',
  // },
  // TENDER: {
  //   TENDER_DETAIL: 'tender-detail',
  //   INVITED_VENDOR: 'tender-invited',
  // },
  // TENDER_STATUS: {
  //   TENDER_STATUS_DETAIL: 'tender-status-detail',
  // },

  USER_MANAGEMENT: {
    DETAIL: 'user-detail',
    DATATABLES: 'user-datatables',
    PROFILE: 'get-user-profile',
  },
  BUSINESS_AREA: {
    DETAIL: 'business-area-detail',
    DATA_TABLES: 'business-area-datatables',
    STORE_LIST: 'business-area-store-list',
  },
  STORE: {
    DETAIL: 'store-detail',
    DATA_TABLES: 'store-datatables',
  },
  UOM: {
    DETAIL: 'uom-detail',
    DETAIL_BY_CODE: 'detail-by-code',
    DATA_TABLES: 'store-datatables',
  },
  TEAM: {
    GET_BY_STORE_ID: 'team-detail-by-store-id',
  },
  CUSTOMER: {
    GET_DEFAULT_CUSTOMER: 'get-default-customer',
  },
  TRANSACTION: {
    GET_NEXT_NOTA_NUMBER: 'get-next-nota-number',
    GET_TRANSFER_BY_ID: 'get-transfer-by-id',
  },
  SALES: {
    GET_BY_ID: 'get-by-id',
    REVOKE_BY_ID: 'revoke-by-id',
    GET_SALES_ITEM_BY_SALES_ID: 'get-sales-item-by-sales-id',
  },
  REPORT: {
    SALES_LIST: 'sales-list-X',
    SALES_LIST_Y: 'sales-list-Y',
    SALES_PER_STORE: 'sales-per-store',
    SALES_BY_PERIOD: 'sales-by-periode',
    SALES_ASSORTMENT: 'sales-assortment',
    SALES_ASSORTMENT_TOTAL: 'sales-assortment-total',
    SALES_ALL_STORE: 'sales-all-store',
    SALES_ARTICLE_GROUP: 'sales-article-group',
    STOCK_BY_STORE: 'stock-by-store',
    STOCK_ANALYZE: 'stock-analyze',
    STOCK_ANALYZE_IN_TOTAL: 'stock-analyze-in-total',
    STOCK_PER_STORE: 'stock-per-store',
    STOCK_PER_STORE_IN_TOTAL: 'stock-per-store-in-total',
    INCOMING_PRODUCT_BY_PERIOD: 'incoming-product-by-periode',
    OUTGOING_PRODUCT_BY_PERIOD: 'outgoing-product-by-periode',
    INCOMING_MOVEMENT: 'incoming-movement',
    OUTGOING_MOVEMENT: 'outgoing-movement',
    PRODUCT_AGE: 'product-age',
    SALES_SUMMARY: 'sales-summary',
    SALES_RECAP: 'sales-recap',
    REAL_STOCK: 'real-stock',
    REAL_STOCK_IN_TOTAL: 'real-stock-in-total',
    YEARLY_SALES: 'yearly-sales',
  },
}

export {QUERIES}
